import { typographyV2 } from '@toggle/design-system';
import { PriceStatus } from '@toggle/helpers';
import styled from 'styled-components';

import { priceChangeColors } from '~/utils/common/utils';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

export const ThemeNameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  ${ThemeLogoIcon.Styled.StyledLogoImg} {
    width: 28px;
    height: 28px;
  }
`;

export const ThemeName = styled.span`
  ${typographyV2.bodySm};
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--kg-theme);
  height: 28px;
  width: 28px;
  border-radius: 40px;
  color: var(--text-default);
  ${typographyV2.titleSm}
`;

export const ChangeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const ChangeValue = styled.span<{ $status: PriceStatus }>`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodySm};
  color: ${({ $status }) => priceChangeColors[$status]};
`;

export const CatalystsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MoreCount = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;
